module.exports = __webpack_public_path__ + "c600a4f9b1546b6606f7ae862db49fd7.png";